export default "__VITE_ASSET__4b3dc8d7__"